import { render } from "./uploadstudyprotocol.vue?vue&type=template&id=63f2ed3f&scoped=true"
import script from "./uploadstudyprotocol.vue?vue&type=script&lang=js"
export * from "./uploadstudyprotocol.vue?vue&type=script&lang=js"

import "./uploadstudyprotocol.vue?vue&type=style&index=0&id=63f2ed3f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f2ed3f"]])

export default __exports__